<template>
    <section class="pt-28 mb-2">
        <div class="container mx-auto px-3">
            <div class="grid grid-cols-12 top flex items-center justify-between">
                <div class="col-span-12 md:col-span-6 order-1">
                    <h2 class="section__title">{{ $t("dutySchedule") }}</h2>
                </div>
                <div class="col-span-12 order-2 md:order-3">
                    <path-navigation class="mt-6" />
                </div>
            </div>
        </div>
    </section>
    <div class="container mx-auto px-3 mt-10">
        <c-overlay :loading="loading">
            <div class="overflow-y-auto">
                <n-table>
                    <thead>
                        <tr>
                            <th>No.</th>
                            <th class="py-5" scope="col">{{ $t("region") }}</th>
                            <th class="py-5" scope="col">{{ $t("dutyMonth") }}</th>
                            <th class="py-5" scope="col">{{ $t("actions") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <td>
                                {{ index + 1 }}
                            </td>
                            <td>
                                {{ item?.[$localeKey("regionName")] }}
                            </td>
                            <td>
                                {{ $t(item?.month?.toLowerCase()) }}
                            </td>
                            <td class="whitespace-nowrap">
                                <div class="h-full flex items-center">
                                    <button @click.prevent="viewRequest(item)"
                                        class="hover:scale-105 active:scale-95 transition ml-4">
                                        <tooltip-slot :label="$t('view')">
                                            <inline-svg width="18" height="18"
                                                :src="require('@/assets/img/orders/visibility.svg')" />
                                        </tooltip-slot>
                                    </button>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </n-table>
            </div>
        </c-overlay>
    </div>
</template>

<script>
import DutyTableService from "@/services/dutyTable.service.js";
import LawyerService from "@/services/lawyer/lawyer.service";

export default {
    data() {
        return {
            list: [],
            total: 0,
            regionList: [],
            loading: false,
            params: {
                page: 1,
                limit: 200,
            },
        };
    },
    watch: {
        params: {
            handler() {
                this.getList();
            },
            deep: true,
        },
        regionId: function () {
            if (this.regionId) {
                this.viewRequest(this.selectedItem);
            }
        },
    },
    computed: {},
    methods: {
        async viewRequest(item) {
            this.$router.push(`/duty-table/view/${item.id}`);
        },
        async getRegionList() {
            try {
                const response = await LawyerService.RegionList();

                this.regionList = response.data?.find((f) => f.id === 3)?.children;
            } catch (error) {
                console.log(error);
            }
        },
        async getList() {
            try {
                let data = {
                    search: this.search ?? "",
                    status: ["ACTIVE"],
                    params: {
                        page: this.params?.page - 1,
                        limit: this.params?.limit,
                    },
                };

                const response = await DutyTableService.getList(data);

                this.list = response.data.list;
                this.total = response.data.total;
            } catch (error) {
                console.log(error);
            }
        },
    },
    async created() {
        this.getList();
        await this.getRegionList();
    },
};
</script>

<style lang="scss">
.custom__status__tab {
    .card-body {
        padding: 0;
    }
}

.tab__pod__label {
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    line-height: 36px;

    color: #001b5c;
}

.late__request {

    td,
    th {
        background-color: #f8d7da !important;
    }
}
</style>
